import React from 'react';
import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import './Station.css';

const Station = () => {
  const { t } = useTranslation();

  // Buradaki verileri kendi ekipmanlarına göre güncelleyebilirsin
  const equipmentData = {
    radios: [
      { id: 1, name: "Yaesu FT-710", type: "HF Transceiver", desc: "station.desc_ft710", image: "/images/a1.jpg" },
      { id: 2, name: "Yaesu FT-891", type: "HF Transceiver", desc: "station.desc_ft891", image: "/images/ft-891.jpg" },
      { id: 3, name: "AnyTone AT-D878UV II", type: "Handheld DMR", desc: "station.desc_d878uv", image: "/images/anytone.jpg" },
      { id: 4, name: "Quansheng UV-K6", type: "Handheld Analog", desc: "station.desc_uvk6", image: "/images/uvk6.png" },
    ],
    antennas: [
      { id: 5, name: "Yaesu ATAS 120A", type: "HF Automatic", desc: "station.desc_atas120a", image: "/images/atas120a.jpg" },
      { id: 6, name: "End-Fed Half Wave (EFHW)", type: "HF Wire", desc: "station.desc_efhw", image: "/images/efhw.jpg" },
      { id: 7, name: "Diamond vX50", type: "VHF/UHF Vertical", desc: "station.desc_vx50", image: "/images/vx50.jpg" },
      { id: 8, name: "Diamond X30", type: "VHF/UHF Vertical", desc: "station.desc_x30", image: "/images/x30.jpg" }
    ],
    accessories: [
      { id: 9, name: "CG-3000 Automatic Tuner", type: "Tuner", desc: "station.desc_cg3000", image: "/images/cg3000.jpg" },
      { id: 10, name: "Yaesu FC-50 Automatic Tuner", type: "Tuner", desc: "station.desc_fc50", image: "/images/fc50.jpg" }
    ]
  };

  const renderCategory = (titleKey, items) => (
    <div className="station-category">
      <h3>{t(titleKey)}</h3>
      <div className="equipment-grid">
        {items.map(item => (
          <div key={item.id} className="equipment-card">
            <div className="equipment-image-container">
              <img 
                src={item.image} 
                alt={item.name} 
                className="equipment-image"
                onError={(e) => {e.target.onerror = null; e.target.src="https://via.placeholder.com/300x200?text=No+Image"}}
              />
            </div>
            <h4>{item.name}</h4>
            <span className="equipment-type">{item.type}</span>
            <p>{t(item.desc)}</p>
          </div>
        ))}
      </div>
    </div>
  );

  return (
    <div className="page station-page">
      <Helmet>
        <title>{t('navbar.equipment')} - TA2GBO</title>
      </Helmet>
      <h2>{t('navbar.equipment')}</h2>
      <div className="station-content">
        {renderCategory('station.radios', equipmentData.radios)}
        {renderCategory('station.antennas', equipmentData.antennas)}
        {renderCategory('station.accessories', equipmentData.accessories)}
      </div>
    </div>
  );
};

export default Station;